
import Swiper from "swiper";
import { Navigation, Keyboard, Autoplay } from "swiper/modules";
// import customSelect from "../modules/select";
import '../modules/consultationForm';
import { searchMBA } from '../modules/exploreSection.js';
import {setAdBannersforMobOrDesk} from '../modules/banners';
import testimonialsSlider from '../modules/testimonials';
import rankingSchoolsGrid from '../modules/rankingSchoolsGrid';
import fitTooltips from '../modules/fitTooltips';



function toolsSlider() {
    const toolsContainer = document.querySelector('[data-module="tools-slider"]');
    if (toolsContainer) {
        const toolsConfig = {
            modules: [Navigation, Keyboard, Autoplay],
            // direction: 'vertical',
            loop: true,
            slidesPerView: 1,
            spaceBetween: 25,
            initialSlide: toolsContainer.dataset.initialSlide,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
            },
            navigation: {
                nextEl: ".tools .unm-slider-btn-next",
                prevEl: ".tools .unm-slider-btn-prev",
            },
        };

        const toolsSwiper = new Swiper(`[data-module="tools-slider"] .swiper`, toolsConfig);

        return toolsSwiper;
    }
}

function studentExpSlider() {
    const trendingContainer = document.querySelector(
        '[data-module="student-exp-slider"]'
    );

    if (trendingContainer) {
        const slideCount = trendingContainer.querySelectorAll('.swiper-slide').length;

        const trendingConfig = {
            modules: [Navigation, Keyboard, Autoplay],
            // direction: 'vertical',
            loop: true,
            slidesPerView: 1,
            spaceBetween: 25,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
            },
            breakpoints: {
                // when window width is >= 480px
                650: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                    loop: slideCount > 2 ? true : false,
                },
                // when window width is >= 640px
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 25,
                    loop: slideCount > 3 ? true : false,
                },
            },
            navigation: {
                nextEl: '[data-module="student-exp-slider"] .unm-slider-btn-next',
                prevEl: '[data-module="student-exp-slider"] .unm-slider-btn-prev',
            },
            watchOverflow: true,
        };

        const trendingSwiper = new Swiper(
            '[data-module="student-exp-slider"] .swiper',
            trendingConfig
        );
        return trendingSwiper;
    }
}

function schoolsSlider() {
    const schoolsContainer = document.querySelector(
        '[data-module="schools-slider"]'
    );

    if (schoolsContainer) {
        const slideCount = schoolsContainer.querySelectorAll('.swiper-slide').length;

        const schoolsConfig = {
            modules: [Navigation, Keyboard, Autoplay],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 25,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
            },
            breakpoints: {
                // when window width is >= 768px
                768: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                    loop: slideCount > 2 ? true : false,
                },
                // when window width is >= 1200px
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 25,
                    loop: slideCount > 4 ? true : false,
                },
            },
            navigation: {
                nextEl: '[data-module="schools-slider"] .unm-slider-btn-next',
                prevEl: '[data-module="schools-slider"] .unm-slider-btn-prev',
            },
            watchOverflow: true,
        };

        const schoolsSwiper = new Swiper(
            '[data-module="schools-slider"] .swiper',
            schoolsConfig
        );
        return schoolsSwiper;
    }
}

function careersSlider() {
    const careersContainer = document.querySelector(
        '[data-module="careers-slider"]'
    );

    if (careersContainer) {
        const slideCount = careersContainer.querySelectorAll('.swiper-slide').length;

        const careersConfig = {
            modules: [Navigation, Keyboard, Autoplay],
            // direction: 'vertical',
            loop: true,
            slidesPerView: 1,
            spaceBetween: 25,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            autoplay: {
                delay: 3000,
                pauseOnMouseEnter: true
            },
            breakpoints: {
                // when window width is >= 768px
                768: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                    loop: slideCount > 2 ? true : false,

                },
                // when window width is >= 1224px
                1224: {
                    slidesPerView: 4,
                    spaceBetween: 25,
                    loop: slideCount > 4 ? true : false,
                }
            },
            pagination: {
                el: '.career-opportunities-articles .swiper-pagination',
            },
            navigation: {
                nextEl: '.career-opportunities-articles .unm-slider-btn-next',
                prevEl: '.career-opportunities-articles .unm-slider-btn-prev',
            },
            watchOverflow: true,
        }

        const careerArticlesSwiper = new Swiper('[data-module="careers-slider"] .swiper', careersConfig);
        return careerArticlesSwiper;
    }
}

function countriesSlider() {
    const countriesContainer = document.querySelector(
        '[data-module="countries-slider"]'
    );

    if (countriesContainer) {
        const slideCount = countriesContainer.querySelectorAll('.swiper-slide').length;

        const countriesConfig = {
            modules: [Navigation, Keyboard, Autoplay],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 25,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
            },
            breakpoints: {
                // when window width is >= 768px
                768: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                    loop: slideCount > 2 ? true : false,

                },
                // when window width is >= 1200px
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 25,
                    loop: slideCount > 4 ? true : false,
                },
            },
            navigation: {
                nextEl: '[data-module="countries-slider"] .unm-slider-btn-next',
                prevEl: '[data-module="countries-slider"] .unm-slider-btn-prev',
            },
            watchOverflow: true,
        };

        const countriesSwiper = new Swiper(
            '[data-module="countries-slider"] .swiper',
            countriesConfig
        );
        return countriesSwiper;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    toolsSlider();
    studentExpSlider();

    schoolsSlider();
    careersSlider();
    testimonialsSlider();
    rankingSchoolsGrid();
    countriesSlider();
    fitTooltips();
//     customSelect({ removeItemButton: true });
    searchMBA();
    setAdBannersforMobOrDesk();
});